
export enum ViewMode {

    ERROR,
    MOBILE,
    DESKTOP,
    LOADING,

}
